module.exports = __webpack_public_path__ + "img/dljcndc_s.5ee18b9.png";